var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsultationIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4755_49885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4993 7.50011C17.0827 4.36913 14.4598 1.93228 11.3011 1.72289C10.1713 1.648 8.99176 1.64815 7.86429 1.72289C4.55274 1.94241 1.91492 4.61024 1.69787 7.95944C1.6554 8.61485 1.6554 9.29368 1.69787 9.9491C1.77692 11.1688 2.3179 12.2983 2.95477 13.252C3.32456 13.9197 3.08051 14.7529 2.69535 15.4808C2.41763 16.0057 2.27877 16.2681 2.39026 16.4577C2.50176 16.6472 2.7508 16.6533 3.2489 16.6653C4.23391 16.6893 4.89813 16.4108 5.42538 16.023C5.72441 15.8032 5.87393 15.6932 5.97699 15.6806C6.06083 15.6703 6.21072 15.7235 6.48214 15.8334",
    stroke: "#888888",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2487 18.0393C10.1572 17.9053 8.49116 16.2749 8.35407 14.2282C8.32729 13.8277 8.32729 13.4128 8.35407 13.0123C8.49116 10.9656 10.1572 9.33517 12.2487 9.20109C12.9622 9.15526 13.7072 9.15542 14.4193 9.20109C16.5108 9.33517 18.1768 10.9656 18.3139 13.0123C18.3407 13.4128 18.3407 13.8277 18.3139 14.2282C18.2639 14.9736 17.9222 15.6638 17.5201 16.2466C17.2865 16.6547 17.4407 17.1638 17.6839 17.6087C17.8593 17.9294 17.947 18.0898 17.8766 18.2057C17.8062 18.3215 17.6488 18.3252 17.3342 18.3326C16.7122 18.3472 16.2927 18.177 15.9597 17.94C15.7708 17.8057 15.6763 17.7385 15.6112 17.7308C15.5462 17.723 15.4181 17.7739 15.162 17.8758C14.9318 17.9672 14.6645 18.0237 14.4193 18.0393C13.7072 18.0851 12.9622 18.0852 12.2487 18.0393Z",
    stroke: "#888888",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4755_49885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultationIcons);
export default __webpack_public_path__ + "static/media/Consultation-icons.3c111bc282e73ef868e6efede4aef52b.svg";
export { ForwardRef as ReactComponent };